import { useMutation } from "react-query";
import {
  apiUpdateContractEndNote,
  TUpdateContractEndNoteRequest,
} from "../../../../../api/contract/apiUpdateContractEndNote";
import { MutationConfig, queryClient } from "../../../../../lib/react-query";
import { contractKeys } from "../util/contract.query-keys";

type TUpdateContractEndNote = TUpdateContractEndNoteRequest & {
  contractId: string;
};

export const updateContractEndNote = ({
  contractId,
  ...payload
}: TUpdateContractEndNote) => {
  return apiUpdateContractEndNote(contractId, payload);
};

type TUseUpdateContractEndNote = {
  config?: MutationConfig<typeof updateContractEndNote>;
};

export const useUpdateContractEndNote = ({
  config,
}: TUseUpdateContractEndNote = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries(contractKeys.all);
    },
    ...config,
    mutationFn: updateContractEndNote,
  });
};
